module.exports = __webpack_public_path__ + "static/img/zp_666.399f062.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zp_666.jpg
// module id = prx0
// module chunks = 4